"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const Link_1 = __importDefault(require("../../../Link"));
const styles = require('./SocialLink.module.scss');
const SocialLink = ({ className = '', href, icon, iconTitle, size = 'lg', trackingAttributes, }) => (react_1.default.createElement(Link_1.default, { trackingAttributes: trackingAttributes, className: (0, classnames_1.default)(styles.socialLink, className), href: href, target: "_blank", rel: "noopener noreferrer" },
    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, title: iconTitle, size: size })));
exports.default = (0, react_1.memo)(SocialLink);
//# sourceMappingURL=SocialLink.js.map